import React from 'react'

import { IconProps } from './types'

const Minus: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    stroke={color}
    {...rest}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18 12H6"
    />
  </svg>
)
Minus.defaultProps = {
  size: 24,
  color: 'currentColor',
}

export default Minus
